import type { Locale } from "@/lib/i18n";
import { pl, type WFaqTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const wFaqTranslations: Record<Locale, WFaqTranslations> = {
  pl,
  en,
  de,
};

export type { WFaqTranslations };
